import React from 'react'
import styles from './advertisementIdAdd.jcss'
import EditText from 'blocks.simple/editText/editText'
import translate from 'core/translate'
import Button from 'blocks.simple/button/button'
import { AdvertisementId } from '../advertisementIds'
import { cn } from 'ethcss'

export const AdvertisementIdAdd = ({
    advertisementId,
    onChange,
    onClose,
    onSave,
}: {
    advertisementId: AdvertisementId
    onChange: (field: string, value: string) => void
    onClose: () => void
    onSave: () => void
}) => {
    return advertisementId ? (
        <div className={styles.advertisementIdAdd}>
            <div className={styles.inner}>
                <div className={styles.field}>
                    <EditText
                        value={advertisementId.name}
                        onChange={(value: string) => {
                            onChange('name', value)
                        }}
                        containerClass={styles.separator}
                        className={cn(styles.input, 'test-zone-id-input')}
                        label={translate('name')}
                    />
                </div>
                <div className={styles.controls}>
                    <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                        {translate('cancel')}
                    </Button>
                    <Button
                        mod="fill"
                        className={cn(styles.button, 'test-save-zone-id')}
                        onClick={onSave}
                        disabled={!advertisementId.name}
                    >
                        {translate(advertisementId.id ? 'save' : 'create')}
                    </Button>
                </div>
            </div>
        </div>
    ) : null
}
